import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, map, Subscription } from 'rxjs';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule, NgIf],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnDestroy {
  items: MenuItem[] = [];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/dashboard', tooltip: 'Início' };

  private sub!: Subscription;

  constructor(private router: Router, private route: ActivatedRoute) {
    // reconstrói a trilha a cada navegação concluída
    this.sub = this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map(() => this.buildCrumbs(this.route.root))
      )
      .subscribe(list => (this.items = list));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private buildCrumbs(root: ActivatedRoute): MenuItem[] {
    const crumbs: MenuItem[] = [];
    let snap: ActivatedRouteSnapshot | null = root.snapshot;

    while (snap) {
      const cfg = snap.routeConfig;
      const data = snap.data ?? {};

      // só entra no breadcrumb se a rota tiver componente (ou o filho tiver)
      const hasComponent = !!cfg?.component || !!snap.firstChild?.routeConfig?.component;

      if (data['breadcrumb'] && hasComponent) {
        const label =
          typeof data['breadcrumb'] === 'function'
            ? data['breadcrumb'](snap)
            : data['breadcrumb'];

        const url = '/' + this.buildUrlFromRoot(snap);
        crumbs.push({ label, routerLink: url });
      }

      snap = snap.firstChild ?? null;
    }

    return crumbs;
  }

  private buildUrlFromRoot(snap: ActivatedRouteSnapshot): string {
    const segments: string[] = [];
    let node: ActivatedRouteSnapshot | null = snap;

    while (node) {
      if (node.url?.length) {
        segments.push(node.url.map(u => u.path).join('/'));
      }
      node = node.parent;
    }

    return segments.reverse().join('/');
  }
}
